import React, {Component} from 'react';
import { Link } from "react-router-dom";
import { ServiceCollectionParam } from "./ServiceCollection";

export default class Menu extends Component<ServiceCollectionParam, {}> {

    state : { links: any[] } = {
        links: []
    };

    componentDidMount() {
        const settings = this.props.services.uiSettings;

        let currentUser = this.props.services.auth.getAuthCredentials().userName;

        const isVisible = (entry: any) => {
            return settings.isAdmin && !entry.isDb
               || entry.isPublic
               || entry.isReg && settings.showRegistrationPage
               || entry.isDb && settings.showDbPage;
        }

        const links = [
            {url: `/results/${currentUser}`, text: 'Projekt', isPublic: true },
            {url: `/reviews/${currentUser}`, text: 'Ülevaatused', isPublic: true },
            {url: `/db-info/${currentUser}`, text: 'Andmebaas', isDb: true },
            {url: `/registration`, text: 'Registreerimine', isReg: true },
            {url: '/results', text: 'Projekt list'},
            {url: '/review-conflicts', text: 'Konfliktid'},
            {url: '/tag-matches', text: 'Kattuvused'},
            {url: '/course-results', text: 'Hinded'},
            {url: '/input', text: 'Sisestus'},
            {url: '/admin', text: 'Admin'}
        ].filter(isVisible);

        this.state.links = links;

        this.setState(this.state);
    }

    logOut() {
        this.props.services.auth.logOut();

        this.props.services.history.push('/login');
    }

    render() {
        const currentPath = this.props.services.location?.pathname;

        return (
            <nav className="navbar navbar-expand-lg navbar-light bg-light px-1 py-1 mt-2 mb-4">
                <div className="navbar-nav">
                {
                    this.state.links.map(link => (
                        <Link to={ link.url }
                              className={`nav-item nav-link ${currentPath === link.url  ? 'active' : ''}`}
                              key={ link.url }>{ link.text }</Link>
                    ))
                }
                </div>

                <div className="navbar-nav ms-auto">
                    <div>
                        <a href="./login"
                           className="nav-item nav-link"
                           onClick={ this.logOut.bind(this) }>Logi välja</a>
                    </div>
                </div>
            </nav>);
    }
}
